import { lazy } from "react";
import { L, type RouteDef } from "./shared";

// Business Continuity Pages
const PartnerExitPlanning = lazy(
  () => import("@/pages/business-continuity/PartnerExitPlanning"),
);
const FamilyBusinessContinuity = lazy(
  () => import("@/pages/business-continuity/FamilyBusinessContinuity"),
);
const OwnerDependencyRisk = lazy(
  () => import("@/pages/business-continuity/OwnerDependencyRisk"),
);
const ValuationReadiness = lazy(
  () => import("@/pages/business-continuity/ValuationReadiness"),
);
const ArizonaBuySellFunding = lazy(
  () => import("@/pages/business-continuity/ArizonaBuySellFunding"),
);
const ArizonaKeyPersonProtection = lazy(
  () => import("@/pages/business-continuity/ArizonaKeyPersonProtection"),
);
const ArizonaExecutiveBenefits = lazy(
  () => import("@/pages/business-continuity/ArizonaExecutiveBenefits"),
);
const ArizonaBusinessOwnerEstatePlanning = lazy(
  () =>
    import("@/pages/business-continuity/ArizonaBusinessOwnerEstatePlanning"),
);
const WealthPreservationBusinessOwners = lazy(
  () => import("@/pages/business-continuity/WealthPreservationBusinessOwners"),
);

// Loan Pages
const CommercialLoansPhoenix = lazy(
  () => import("@/pages/loans/CommercialLoansPhoenix"),
);
const BusinessLineOfCreditArizona = lazy(
  () => import("@/pages/loans/BusinessLineOfCreditArizona"),
);
const SBALoansPhoenixScottsdale = lazy(
  () => import("@/pages/loans/SBALoansPhoenixScottsdale"),
);
const EquipmentFinancingContractors = lazy(
  () => import("@/pages/loans/EquipmentFinancingContractors"),
);
const WorkingCapitalSmallBusiness = lazy(
  () => import("@/pages/loans/WorkingCapitalSmallBusiness"),
);
const CommercialRealEstateArizona = lazy(
  () => import("@/pages/loans/CommercialRealEstateArizona"),
);
const BusinessAcquisitionFinancing = lazy(
  () => import("@/pages/loans/BusinessAcquisitionFinancing"),
);
const MedicalPracticeFinancing = lazy(
  () => import("@/pages/loans/MedicalPracticeFinancing"),
);
const ConstructionCompanyFinancing = lazy(
  () => import("@/pages/loans/ConstructionCompanyFinancing"),
);
const ManufacturingEquipmentFinancing = lazy(
  () => import("@/pages/loans/ManufacturingEquipmentFinancing"),
);

// Expert Insights Articles
const ArticleBuySellAgreements = lazy(
  () => import("@/pages/insights/ArticleBuySellAgreements"),
);
const ArticleOwnerDeath = lazy(
  () => import("@/pages/insights/ArticleOwnerDeath"),
);
const ArticleCommercialLending = lazy(
  () => import("@/pages/insights/ArticleCommercialLending"),
);
const ArticleKeyPersonRisk = lazy(
  () => import("@/pages/insights/ArticleKeyPersonRisk"),
);
const ArticleBankDecline = lazy(
  () => import("@/pages/insights/ArticleBankDecline"),
);
const ArticleExecutiveBenefits = lazy(
  () => import("@/pages/insights/ArticleExecutiveBenefits"),
);
const ArticleWealthPreservation = lazy(
  () => import("@/pages/insights/ArticleWealthPreservation"),
);
const ArticleLoanReview = lazy(
  () => import("@/pages/insights/ArticleLoanReview"),
);
const ArticleSuccessionChecklist = lazy(
  () => import("@/pages/insights/ArticleSuccessionChecklist"),
);
const ArticleTrustPlanning = lazy(
  () => import("@/pages/insights/ArticleTrustPlanning"),
);
const ArticleBuySellFundingArizona = lazy(
  () => import("@/pages/insights/ArticleBuySellFundingArizona"),
);
const ArticleEconomicDiversification = lazy(
  () => import("@/pages/insights/ArticleEconomicDiversification"),
);

export const contentRoutes: RouteDef[] = [
  // Business Continuity Pages
  {
    path: "/business-continuity/partner-exit-planning",
    element: (
      <L>
        <PartnerExitPlanning />
      </L>
    ),
  },
  {
    path: "/business-continuity/family-business-continuity",
    element: (
      <L>
        <FamilyBusinessContinuity />
      </L>
    ),
  },
  {
    path: "/business-continuity/owner-dependency-risk",
    element: (
      <L>
        <OwnerDependencyRisk />
      </L>
    ),
  },
  {
    path: "/business-continuity/valuation-readiness",
    element: (
      <L>
        <ValuationReadiness />
      </L>
    ),
  },
  {
    path: "/business-continuity/arizona-buy-sell-funding",
    element: (
      <L>
        <ArizonaBuySellFunding />
      </L>
    ),
  },
  {
    path: "/business-continuity/arizona-key-person-protection",
    element: (
      <L>
        <ArizonaKeyPersonProtection />
      </L>
    ),
  },
  {
    path: "/business-continuity/arizona-executive-benefits",
    element: (
      <L>
        <ArizonaExecutiveBenefits />
      </L>
    ),
  },
  {
    path: "/business-continuity/arizona-business-owner-estate-planning",
    element: (
      <L>
        <ArizonaBusinessOwnerEstatePlanning />
      </L>
    ),
  },
  {
    path: "/business-continuity/wealth-preservation-business-owners",
    element: (
      <L>
        <WealthPreservationBusinessOwners />
      </L>
    ),
  },
  // Commercial Loan Pages
  {
    path: "/loans/commercial-loans-phoenix",
    element: (
      <L>
        <CommercialLoansPhoenix />
      </L>
    ),
  },
  {
    path: "/loans/business-line-of-credit-arizona",
    element: (
      <L>
        <BusinessLineOfCreditArizona />
      </L>
    ),
  },
  {
    path: "/loans/sba-loans-phoenix-scottsdale",
    element: (
      <L>
        <SBALoansPhoenixScottsdale />
      </L>
    ),
  },
  {
    path: "/loans/equipment-financing-contractors",
    element: (
      <L>
        <EquipmentFinancingContractors />
      </L>
    ),
  },
  {
    path: "/loans/working-capital-small-businesses",
    element: (
      <L>
        <WorkingCapitalSmallBusiness />
      </L>
    ),
  },
  {
    path: "/loans/commercial-real-estate-arizona",
    element: (
      <L>
        <CommercialRealEstateArizona />
      </L>
    ),
  },
  {
    path: "/loans/business-acquisition-financing",
    element: (
      <L>
        <BusinessAcquisitionFinancing />
      </L>
    ),
  },
  {
    path: "/loans/medical-practice-financing",
    element: (
      <L>
        <MedicalPracticeFinancing />
      </L>
    ),
  },
  {
    path: "/loans/construction-company-financing",
    element: (
      <L>
        <ConstructionCompanyFinancing />
      </L>
    ),
  },
  {
    path: "/loans/manufacturing-equipment-financing",
    element: (
      <L>
        <ManufacturingEquipmentFinancing />
      </L>
    ),
  },
  // Expert Insights
  {
    path: "/insights/buy-sell-agreements-enterprise-value",
    element: (
      <L>
        <ArticleBuySellAgreements />
      </L>
    ),
  },
  {
    path: "/insights/what-happens-when-owner-dies",
    element: (
      <L>
        <ArticleOwnerDeath />
      </L>
    ),
  },
  {
    path: "/insights/commercial-loan-vs-line-of-credit",
    element: (
      <L>
        <ArticleCommercialLending />
      </L>
    ),
  },
  {
    path: "/insights/key-person-risk-lending-succession",
    element: (
      <L>
        <ArticleKeyPersonRisk />
      </L>
    ),
  },
  {
    path: "/insights/why-banks-decline-strong-revenue",
    element: (
      <L>
        <ArticleBankDecline />
      </L>
    ),
  },
  {
    path: "/insights/executive-benefits-retain-leadership",
    element: (
      <L>
        <ArticleExecutiveBenefits />
      </L>
    ),
  },
  {
    path: "/insights/business-owner-wealth-preservation",
    element: (
      <L>
        <ArticleWealthPreservation />
      </L>
    ),
  },
  {
    path: "/insights/prepare-commercial-loan-review",
    element: (
      <L>
        <ArticleLoanReview />
      </L>
    ),
  },
  {
    path: "/insights/business-succession-checklist-arizona",
    element: (
      <L>
        <ArticleSuccessionChecklist />
      </L>
    ),
  },
  {
    path: "/insights/trust-planning-business-continuity",
    element: (
      <L>
        <ArticleTrustPlanning />
      </L>
    ),
  },
  {
    path: "/insights/buy-sell-agreement-funding-arizona",
    element: (
      <L>
        <ArticleBuySellFundingArizona />
      </L>
    ),
  },
  {
    path: "/insights/economic-diversification-financial-safety-nets",
    element: (
      <L>
        <ArticleEconomicDiversification />
      </L>
    ),
  },
];
